import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/Shared/Spinner";
import AddBook from "../../components/Dashboard/Books/AddBook";
import { GetAllBooks } from "../../api/Books/GetAllBooks";
import BookCard from "../../components/Dashboard/Books/BookCard";
import MoneyIcon from "../../components/Icons/MoneyIcon";
import { Link } from "react-router-dom";
import { useUserDataStore } from "../../stores/user";
const Books = () => {
  const { userData } = useUserDataStore();

  const [showAddCourse, setShowAddCourse] = useState(false);
  const { data: BooksResponse, isLoading: isCoursesLoading } = useQuery({
    queryFn: GetAllBooks,
    queryKey: ["books"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const books = BooksResponse?.data?.bookData || [];

  const handleAddCourseSuccess = () => {
    setShowAddCourse(false);
  };

  if (isCoursesLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div>
      {showAddCourse ? (
        <AddBook onSuccess={handleAddCourseSuccess} />
      ) : (
        <div>
          <div className="flex justify-between items-center py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">Books</h1>
            <div className="flex gap-4">
              {userData?.role === "admin" && (
                <>
                  <Button
                    onClick={() => setShowAddCourse(true)}
                    className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                    variant="primary"
                  >
                    <AddIcon className="mr-1.5" />
                    Add New Book
                  </Button>
                  <Link to={"/dashboard/books/purchase-requests"}>
                    <Button
                      className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                      variant="primary"
                    >
                      <MoneyIcon />
                      Purchase Requests
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
          <div className="grid grid-cols-3 place-content-between gap-4">
            {books.map((book) => (
              <BookCard book={book} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Books;
